module.exports = __webpack_public_path__ + "img/paragraph.17fec708.svg";